import Nav from "./nav"
import Search from "./search"
import Dropdown from "./dropdown"
import Filters from "./filters"
import Select2 from "./select2"
import Swipers from "./swipers"

document.addEventListener("DOMContentLoaded", function () {
  Nav(jQuery)
  Search(jQuery)
  Dropdown(jQuery)
  Filters(jQuery)
  Select2(jQuery)
  Swipers(jQuery)
})
